import { connect } from 'react-redux'

import Modals from '@components/Modals'

import services from '@services'

const mapStateToProps = (state) => {
  const {
    calcChefFeesModal,
    editAccountModal,
    editAccountContactModal,
    editBatchOrderModal,
    editChefModal,
    editChefContactModal,
    editChefPayoutsModal,
    editChildMenuItemModal,
    editClientReportingProgramModal,
    editDinerProfileModal,
    editDeliveryZoneModal,
    editHQModal,
    editMenuConceptModal,
    editOrderModal,
    editProposalModal,
    editRecipeModal,
    editServiceDepotModal,
    editServiceItemModal,
    editSnackPackModal,
    editVirtualItemModal,
    editVirtualKitModal,
    editUserModal,
    editChildChefsModal,
    auditHistoryModal,
    chefFutureOrdersModal,
    resultsMessageModal,
    searchViaHubSpotModal,
    editVendorPricingAgreementModal,
    editPDFModal,
    infoModal,
    foodPartnerModal,
  } = state

  return {
    showCalcChefFeesModal: calcChefFeesModal.show,
    showAccount: editAccountModal.show,
    showAccountContact: editAccountContactModal.show,
    showAuditHistory: auditHistoryModal.show,
    showBatchOrder: editBatchOrderModal.show,
    showConcepts: editMenuConceptModal.show,
    showChefContact: editChefContactModal.show,
    showChef: editChefModal.show,
    showChefPayouts: editChefPayoutsModal.show,
    showChefFutureOrders: chefFutureOrdersModal.show,
    showChildMenuItem: editChildMenuItemModal.show,
    showClientReportingProgram: editClientReportingProgramModal.show,
    showDinerProfile: editDinerProfileModal.show,
    showDeliveryZone: editDeliveryZoneModal.show,
    showHQ: editHQModal.show,
    showOrder: editOrderModal.show,
    showProposal: editProposalModal.show,
    showRecipe: editRecipeModal.show,
    showResultsMessageModal: resultsMessageModal.show,
    showServiceDepot: editServiceDepotModal.show,
    showServiceItem: editServiceItemModal.show,
    showSnackPack: editSnackPackModal.show,
    showSearchViaHubSpotModal: searchViaHubSpotModal.show,
    showVirtualItem: editVirtualItemModal.show,
    showVirtualKit: editVirtualKitModal.show,
    showUser: editUserModal.show,
    showEditChildChefs: editChildChefsModal.show,
    showEditVendorPricingAgreement: editVendorPricingAgreementModal.show,
    showEditPDFModal: editPDFModal.show,
    showInfoModal: infoModal.show,
    showFoodPartnerModal: foodPartnerModal.show,
  }
}

const mapDispatchToProps = () => {
  const { UIService } = services

  const { close, confirm } = UIService.ConfirmationModal

  return {
    close,
    confirm,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modals)
